const OPTIONS = [
  { key: "mo", label: "Monthly" },
  { key: "yr", label: "Yearly" },
];

export default function BillingCycleToggle({ value, onChange, className = "" }) {
  return (
    <div
      role="group"
      aria-label="Billing cycle"
      className={`inline-flex items-center bg-gray-100 rounded-full p-1 ${className}`}
    >
      {OPTIONS.map((option) => (
        <button
          key={option.key}
          type="button"
          onClick={() => onChange(option.key)}
          className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
            value === option.key
              ? "bg-khamco-ribbon text-white shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
